import styled from "styled-components";

export const Profile = styled.div`
  display: flex;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #eee;
  margin-top: 10px;

  div {
    text-align: right;
    margin-right: 10px;

    strong {
      display: block;
      color: #fff;
    }

    small {
      color: #fff;
      font-size: 8px;
    }

    a {
      display: block;
      margin-top: 2px;
      font-size: 12px;
      color: #999;
    }
  }
`;

export const Container = styled.div`
  .governo {
    display: flex !important;
  }

  .menu_mobile {
    /* @media (min-width: 50em) {
      display: none;
    } */
  }

  body {
    background: #e9e9e9;
    font-family: "Raleway", sans-serif;
    margin: 0px;
    padding: 0px;
  }

  .standard_layout .content_contain {
    overflow: hidden;
    background: #e9e9e9;
  }

  .mark {
    margin-right: 1.25em;
  }

  .nav_contain {
    display: block;
    padding: 0.75em 0;
    text-align: center;
    ul {
      @media (min-width: 72em) {
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        padding: 0;
        margin: 0;
      }

      li {
        display: block;
        padding: 0.75em 0;
        text-align: center;
        a {
          position: relative;
          display: block;
          color: #090910;
          text-decoration: none;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }
        @media (min-width: 72em) {
          position: relative;
          margin-right: 8.5%;
          border-bottom: none;
        }
      }
    }

    @media (min-width: 72em) {
      max-height: 100vh;
      overflow: visible;
      opacity: 1;
      padding: 0;
      -webkit-transform: none;
      transform: none;
      margin-right: 300px;
    }
  }

  /* HEADER */

  header {
    position: relative;
    z-index: 1000;
    margin: 0 auto;
    background: #fff;
    padding: 1.5em 5.5% 1.25em;
    -webkit-transition: padding 0.3s ease;
    transition: padding 0.3s;
    padding-top: 2.75em;
    background: none;
    background: linear-gradient(to right, #204d37, #00853b 40%);
    height: 186px;
    width: 100%;

    .contain {
      /* padding: 0 1em;
      max-width: 80em; */
      margin: 0 auto;
    }

    &::before {
      content: "";
      position: absolute;
      z-index: -1;
      display: block;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to right, #204d37, #00853b 40%);
      box-shadow: 0 10px 15px -8px rgba(9, 9, 16, 0);
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-transition: box-shadow 0.6s ease;
      transition: box-shadow 0.6s ease;
    }

    .header_content_menu {
      height: 60px;
      display: -webkit-box;
      display: flex;
      -webkit-box-align: none;
      align-items: center;
      background-color: #fff;
      border-bottom: 3px solid #00bd19;
      padding: 15px;
      border-radius: 15px;
      justify-content: space-between;
      margin-top: 30px;
    }

    .page_contain {
      max-width: 100em;
      margin: 0 auto;
      padding: 0 5.5%;
      margin-top: -150;
    }

    .search_box .input_group {
      padding: 0;
      width: 100%;
      -webkit-transition: width 0.5s ease;
      transition: width 0.5s ease;
      margin-right: 30;
    }
  }

  .baseOndas {
    position: absolute;
    padding-top: 38px;
  }

  .baseOndas img {
    height: 20px;
  }

  .appBar {
    display: none;
  }

  .appBar img {
    height: 30px;
    width: 30px;
    margin: 0px 10px;
  }

  .appBar h1 {
    padding-top: 12px;
  }

  .loginContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
  }
  .login {
    margin-left: 5px;
    z-index: 99999999999999;
    cursor: pointer;
  }

  .btnAvatar {
    border: 2px solid #fff;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .labelEco {
    @media (max-width: 50em) {
      display: none !important;
    }
  }

  .labelEcoMobile {
    @media (min-width: 50em) {
      display: none !important;
    }
  }

  .logosEco {
    @media (max-width: 50em) {
      margin: 0 auto !important;
    }
  }

  .profile {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    @media (max-width: 50em) {
    }
  }

  .menu_browser {
    @media (max-width: 50em) {
      display: none;
    }
  }

  .searchable {
    @media (max-width: 72em) {
      display: none;
    }
  }

  @media (min-width: 50em) {
    .mark {
      display: none !important;
    }
  }

  /* nova media */

  @media (max-width: 600px) {
    header {
      width: 100%;
      height: 140px;
    }

    .btnAvatar {
      display: none;
    }

    .nameUser {
      display: none;
    }

    .contain {
      padding-top: 30px;
    }

    .baseOndas img {
      height: 10px;
    }

    .baseOndas {
      position: absolute;
      padding-top: 19px;
    }

    .header_content_menu {
      display: none !important;
    }

    .imgLogo img {
      width: 248px;
      height: 45px;
    }

    .appBar {
      position: fixed;
      z-index: 10000000;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 51px;
      color: #414141;
      padding: 0px 15px;
      background: #ffffff;
      box-shadow: 0 2px 4px -2px rgb(0 0 0 / 50%);
    }
    .btnAvatarMobile {
      border: 2px solid #ffffff;
    }
  }
`;
